<template>
  <div class="pres-2026-col-graph" v-if="graphOptions">
    <v-chart ref="elec2026graph" :autoresize="true" :option="graphOptions" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import VueCompositionAPI from "@vue/composition-api";
import ECharts from "vue-echarts";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { MapChart } from "echarts/charts";
import {
  TitleComponent,
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  GraphicComponent,
  LegendComponent,
  ToolboxComponent,
} from "echarts/components";
import { echartformat } from "../../../functions/general-functions";
const { use } = echarts;
Vue.use(VueCompositionAPI);
use([
  TitleComponent,
  CanvasRenderer,
  MapChart,
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  GraphicComponent,
  LegendComponent,
  ToolboxComponent,
]);

export default {
  components: { "v-chart": ECharts },
  props: {
    location: String,
  },
  created: function () {
    this.initMap();
    this.getGraphData(this.location);
  },
  computed: {
    ...mapGetters("elections", {
      data: "pres2026_2_home",
      colMapJson: "colMap2026",
    }),
    graphOptions: function () {
      if (
        this.colMapJson &&
        this.data.stateGraph &&
        this.data.stateGraph.success
      ) {
        const _self = this;
        return {
          title: {
            show: false,
          },
          textStyle: {
            fontFamily: '"Montserrat", sans-serif',
          },
          tooltip: {
            confine: true,
            trigger: "item",
            textStyle: {
              fontWeight: "600",
              fontSize: 10,
            },
            formatter: function (params) {
              if (params.data && params.data.value) {
                let resTooltip = "";
                let pointer =
                  params.data.value[2] > params.data.value[4] ? 0 : 1;

                resTooltip += `<strong>${params.data.value[1]}</strong>`;
                resTooltip += "<br/>";
                resTooltip += `<span style=\"display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${_self.data.stateGraph.candidates[pointer][1]};\"></span>`;
                resTooltip += _self.data.stateGraph.candidates[pointer][0];
                resTooltip += `<span style="margin-left:4px;">${echartformat(
                  params.data.value[pointer * 2 + 2],
                  "decimal",
                  0,
                )} (${echartformat(
                  params.data.value[pointer * 2 + 3],
                  "percent",
                  2,
                )})</div>`;
                resTooltip += "<br/>";
                pointer = pointer ? 0 : 1;
                resTooltip += `<span style=\"display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${_self.data.stateGraph.candidates[pointer][1]};\"></span>`;
                resTooltip += _self.data.stateGraph.candidates[pointer][0];
                resTooltip += `<span style="margin-left:4px;">${echartformat(
                  params.data.value[pointer * 2 + 2],
                  "decimal",
                  0,
                )} (${echartformat(
                  params.data.value[pointer * 2 + 3],
                  "percent",
                  2,
                )})</div>`;
                return resTooltip;
              }
            },
          },
          series: {
            name: "Votes",
            type: "map",
            roam: true,
            map: "COL",
            zoom: 1.2,
            aspectScale: 1,
            scaleLimit: {
              min: 1.2,
              max: 8,
            },
            itemStyle: {
              areaColor: "#d3d3d3",
              borderColor: "#fff",
              borderWidth: 1,
            },
            select: {
              disabled: true,
            },
            emphasis: {
              label: {
                show: false,
              },
              itemStyle: {
                areaColor: "#d3d3d3",
                borderWidth: 2,
                borderColor: "#aaa",
              },
            },
            data: this.data.stateGraph.datasetValues.slice(1).map((q) => {
              return {
                name: q[0],
                value: q,
                itemStyle: {
                  areaColor:
                    q[2] > q[4]
                      ? _self.data.stateGraph.candidates[0][1]
                      : q[2] < q[4]
                      ? _self.data.stateGraph.candidates[1][1]
                      : "#dadada",
                },
                emphasis: {
                  itemStyle: {
                    areaColor:
                      q[2] > q[4]
                        ? _self.data.stateGraph.candidates[0][1]
                        : q[2] < q[4]
                        ? _self.data.stateGraph.candidates[1][1]
                        : "#dadada",
                    opacity: 0.8,
                  },
                },
              };
            }),
          },
        };
      }
    },
  },
  methods: {
    ...mapActions("elections", {
      getGraphData: "getPres2026_2_Home",
      setGraphData: "setPres2026_2_StateGraph",
      initMap: "initMap2026",
    }),
  },
  watch: {
    colMapJson: function (newVal) {
      if (newVal) {
        echarts.registerMap("COL", newVal);
      }
    },
  },
};
</script>
